<template>
  <section class="content-missing">
    <div class="content-missing__content">
      <div class="content-missing__header">
        <h1 class="content-missing__header__heading">{{heading}}</h1>
      </div>
      <div class="content-missing__text-content">
        <BaseText><p>{{text}}</p></BaseText>
      </div>
      <div class="content-missing__go">
        <router-link
          class="content-missing__go__link"
          v-click-ui-close
          :to="{ path: '/'}">
          Go to start
        </router-link>
      </div>
    </div>
  </section>
</template>
<script>
const error404 = {
  heading: '404',
  text: 'You are looking for something, but nothing can be found.'
}
const errorContentMissing = {
  heading: 'Nothing to see..',
  text: 'The content seems to be missing'
}
export default {
  name: 'missing-view',
  data () {
    return {
      metadata: {
        title: 'Page Missing',
        Description: 'Nothing was found'
      }
    }
  },
  props: {
    errorType: {
      type: String,
      default: null
    }
  },
  computed: {
    text: function () {
      return this.errorType === 'content-missing' ? errorContentMissing.text : error404.text
    },
    heading: function () {
      return this.errorType === 'content-missing' ? errorContentMissing.heading : error404.heading
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "./content-missing";
</style>



// WEBPACK FOOTER //
// src/components/ContentMissing/ContentMissing.vue